import {ValueObject} from '@s-ui/domain'

export class GetDealerRequest extends ValueObject {
  /**
   * @param {Object} param
   * @param {Number|String} param.contractId
   */

  static validate({contractId, invalidDealerRequestError}) {
    if (!contractId) throw invalidDealerRequestError('contractId is required')
  }
}
